@if (gvs.isScheduledInstallNotificationMinimized()) {
    <div 
        class="header-update-warning text-center" 
        (click)="toggleVisibility();"
    >
        <span class="text-info">
            System Update: A system update will occur in the next few minutes. 
        </span>
    </div>
} @else {
    <div class="count-down-timer">
        <button 
            type="button" 
            class="close text-info p-2" 
            aria-label="Close" 
            (click)="toggleVisibility();"
        >
            <span aria-hidden="true">&times;</span>
        </button>

        <h4 class="text-info p-2">System Update:</h4>
        <span class="text-info p-2">A system update will occur in the next few minutes.</span>
    </div>
}